import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private requestCount = 0;

  loadingSubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(true);
  private loading$: Observable<boolean> = this.loadingSubject as Observable<boolean>;

  constructor() {
    // Service initialization
  }

  show(): void {
    this.loadingSubject.next(false);
  }

  hide(): void {
    if (this.requestCount === 0) {
      this.loadingSubject.next(true);
    }
  }

  showKeepCount(): void {
    this.requestCount++;

    if (this.requestCount === 1) {
      this.loadingSubject.next(false);
    }
  }

  hideKeepCount(): void {
    if (this.requestCount > 0) {
      this.requestCount--;
    }

    if (this.requestCount === 0) {
      this.loadingSubject.next(true);
    }
  }

  get loading(): Observable<boolean> {
    return this.loading$;
  }
}
